/**
 * Strong Single Man - Custom Shopify Theme
 * Main JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Strong Single Man theme loaded');

  // Initialize reveal animations
  initRevealAnimations();

  // Initialize mobile menu
  initMobileMenu();

  // Initialize cart functionality (to be built)
  // initCart();
});

/**
 * Reveal on scroll animation
 */
function initRevealAnimations() {
  const revealElements = document.querySelectorAll('.reveal');
  
  if (revealElements.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  revealElements.forEach(el => observer.observe(el));
}

/**
 * Mobile Menu Toggle
 */
function initMobileMenu() {
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const menuOverlay = document.querySelector('[data-mobile-menu-overlay]');
  
  if (!menuToggle || !menuOverlay) return;

  menuToggle.addEventListener('click', () => {
    const isActive = menuToggle.classList.contains('active');
    
    if (isActive) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });

  // Close menu when clicking a link
  const menuLinks = menuOverlay.querySelectorAll('a');
  menuLinks.forEach(link => {
    link.addEventListener('click', () => {
      closeMobileMenu();
    });
  });

  // Close menu on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menuToggle.classList.contains('active')) {
      closeMobileMenu();
    }
  });

  // Close menu when clicking overlay background
  menuOverlay.addEventListener('click', (e) => {
    if (e.target === menuOverlay) {
      closeMobileMenu();
    }
  });

  function openMobileMenu() {
    menuToggle.classList.add('active');
    menuOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    menuToggle.classList.remove('active');
    menuOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

/**
 * Utility: Debounce function
 */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
